import React, { useState, useContext, useEffect } from 'react'
import moment from 'moment'
import axios from 'axios'

import { socket } from '@/product/common/socket'

// import { CKEditor } from '@ckeditor/ckeditor5-react'
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic'

let serverTime = new Date()
const dateFormat = 'DD-MM-YYYY'
const dateTimeFormat = 'DD-MM-YYYY h:mm a'

if (socket) {
    socket.on('sliservertime', (data) => {
        if (moment(data.dTime).isValid()) {
            serverTime = new Date(data.dTime)
        }
    })
}

export const isValidURL = (url) => {
    var urlRegex = new RegExp(
        '^(https?:\\/\\/)?' + // Protocol
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' +
            '((\\d{1,3}\\.){3}\\d{1,3}))' +
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' +
            '(\\?[;&a-z\\d%_.~+=-]*)?' +
            '(\\#[-a-z\\d_]*)?$',
        'i',
    )

    return urlRegex.test(url)
}
export const getImagepath = (path) => {
    if (isValidURL(path)) {
        return path
    } else {
        return `${global.site_url}/uploads/product/${path}`
    }
}
export const sortAllDropDownFunction = (data) => {
    let sortData = []
    if (data?.length) {
        sortData = data?.sort((obj1, obj2) => {
            if (obj1.show == 'Other') return 1
            if (obj2.show == 'Other') return -1
            let nameA = obj1.show?.toLowerCase()
            let nameB = obj2.show?.toLowerCase()

            if (nameA < nameB) return -1
            if (nameA > nameB) return 1
            return 0
        })
    }
    return sortData
}

//sorting
export const sortAllCheckboxFunction = (a) => {
    let sortData = []
    if (a?.length) {
        sortData = a?.sort((obj1, obj2) => {
            if (obj1?.description == 'Other') return 1
            if (obj2?.description == 'Other') return -1
            var nameA = obj1?.description?.toUpperCase() // ignore upper and lowercase
            var nameB = obj2?.description?.toUpperCase() // ignore upper and lowercase
            if (nameA < nameB) {
                return -1
            }
            if (nameA > nameB) {
                return 1
            }
        })
    }
    // names must be equal
    return sortData
}

export const handleRedirectInternal = (history, path) => {
    history.push(`/${path}`)
    window.scrollTo(0, 0)
}
export const dateFormatFront = (data) => {
    return moment(data).isValid()
        ? `${moment(data).format('MMM Do')}, ${moment(data).format('h:mm a')}`
        : '-'
}

export const capitalize = (data) => {
    let dataReturn = '-'
    if (data) {
        dataReturn = data.charAt(0).toUpperCase() + data.slice(1).toLowerCase()
    }
    return dataReturn
}

export const paymentTypeRosoom = (data, t) => {
    let paymentType
    switch (data) {
        case 'CBDD':
            paymentType = 'cbd_direct_debit'
            break
        case 'CCGV':
            paymentType = 'visa_card'
            break
        case 'CCGM':
            paymentType = 'master_card'
            break
        case 'CBDC–CBD':
            paymentType = 'cbd_corporate_direct_debit'
            break
        case 'HSBC–HCBC':
            paymentType = 'hcbc_corporate_direct_debit'
            break
        case 'EBDD':
            paymentType = 'emirates_nbd_bank_direct_debit'
            break
        case 'SCBD':
            paymentType = 'standard_chartered_direct_debit'
            break
        case 'HBZD':
            paymentType = 'habib_bank_direct_debit'
            break
        case 'MBLC':
            paymentType = 'mashreq_bank_corporate_direct_debit'
            break
        case 'DIBD':
            paymentType = 'dubai_islamic_bank_direct_debit'
            break
        case 'SCBC':
            paymentType = 'standard_chartered_corporate_direct_debit'
            break
        case 'MOBE':
            paymentType = 'ministry_of_finance_industry_blue'
            break

        case 'MOGE':
            paymentType = 'ministry_of_finance_industry_gold'
            break
        case 'MORE':
            paymentType = 'ministry_of_finance_industry'
            break
        default:
            paymentType = data
    }
    return paymentType
}

export const HtmlToText = (htmlString) => {
    var stringContainer = document.createElement('span')
    stringContainer.innerHTML = htmlString
    return stringContainer.textContent || stringContainer.innerText || ''
}

export const dateFormatFrontDay = (data) => {
    return `${moment(data).format('MMM Do YYYY')}`
}

export const currencyFormat = (data) => {
    return `${parseFloat(data).toLocaleString('en-GB', {
        style: 'currency',
        currency: 'GBP',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    })}`
}

export const dateFormatFunction = (data) => {
    let dataReturn = '-'
    if (data) {
        if (moment(data).isValid()) {
            dataReturn = `${moment(data).format(dateFormat)}`
        }
    }
    return dataReturn
}

export const timeFormatFunction = (data, customFormate = '') => {
    let dataReturn = '-'
    if (data) {
        if (moment(data).isValid()) {
            if (customFormate) {
                dataReturn = `${moment(data).format(customFormate)}`
            } else {
                dataReturn = `${moment(data).format('h a')}`
            }
        }
    }
    return dataReturn
}

export const hoursMinutesFormateFunction = (data) => {
    if (data) {
        const hours = Math.floor(data / 60)
        const remainingMinutes = data % 60
        const dataReturn = hours > 2 ? 'hrs' : 'hour'

        return (
            <div>
                {`${hours > 0 ? `${hours} ${dataReturn}` : ''} ${
                    remainingMinutes > 0 ? `${remainingMinutes} minutes` : ''
                }  `}
            </div>
        )
    }
}

export const checkProductOpen = (date_added, user_role) => {
    let startDate = new Date(serverTime)
    let addDate = new Date(date_added)
    let milliSeconds = 0
    // if (parseInt(user_role) !== 3) {
    //   milliSeconds = 1 * 3600000;
    // } else {
    // }
    let incrementedTime = addDate.getTime() + parseInt(milliSeconds)
    let newaddDate = new Date(incrementedTime)
    if (newaddDate > startDate) {
        return false
        // let incrementedTime = addDate.getTime() + parseInt(milliSeconds);
        // let timerTime = incrementedTime - startDate.getTime();
        // if (timerTime <= 0) {
        //   return true;
        // } else {
        //   return false;
        // }
    } else {
        return true
    }
}

export const maskEmailFront = (data) => {
    data = data.toString()
    var first4 = data.substring(0, 2)
    var last5 = data.substring(data.length - 2)
    var mask = data.substring(2, data.length - 2).replace(/[^]/g, '*')
    return first4 + mask + last5
}

export const dateFormatFrontOnlyDate = (data) => {
    return `${moment(data).format(dateFormat)}`
}

export const dateTimeFormatFunction = (data) => {
    let dataReturn = '-'
    if (data) {
        if (moment(data).isValid()) {
            dataReturn = `${moment(data).format(dateTimeFormat)}`
        }
    }
    return dataReturn
}

//Custom date and time format for bif history\

export const altDateTimeFormatFunction = (data) => {
    let dateReturn = '-' // Default value for date
    let timeReturn = '-' // Default value for time

    if (data) {
        if (moment(data).isValid()) {
            // Format date and time separately
            dateReturn = `${moment(data).format('DD-MM-YYYY')}` // Example date format
            timeReturn = `${moment(data).format(' h:mm a')}` // Example time format
        }
    }

    // Return date and time separately
    return { date: dateReturn, time: timeReturn }
}

export const DirectAPICAll = (method, url) => {
    return new Promise(async (resolve, reject) => {
        try {
            if (method === 'get') {
                let res = await axios.get(`${url}`)
                console.log('responsode from api', res)
                resolve(res)
            } else if (method === 'post') {
                let res = await axios.post(`${url}`)
                resolve(res)
            }
        } catch (err) {
            console.log('responsode error from api', err)
            resolve(err)
        }
    })
}

export const useCustomMediaQuery = (queryString) => {
    const [isMatch, setIsMatch] = useState(false)
    const mqChange = (mq) => {
        setIsMatch(mq.matches)
    }

    useEffect(() => {
        const mq = window.matchMedia(queryString)
        mq.addListener(mqChange)
        mqChange(mq)

        return () => {
            mq.removeListener(mqChange)
        }
    }, [queryString])

    return isMatch
}

export const handleRedirectInternalWithParams = (history, path, state) => {
    history.push(`/${path}`, state)
    window.scrollTo(0, 0)
}

export function getUserProfileErrorMessage(user) {
    const isGiver = user?.admin
    const hasBothAccess = user?.both_access

    if (isGiver && hasBothAccess) return 'Please update your profile to post offers and place bids.'
    if (isGiver) return 'Please update your profile to post an offer'
    return 'Please update your profile to search for offers and place bids.'
}

export const LINKEDIN_REGEX =
    /^(https?:\/\/)?([a-z]{2}\.)?(www\.)?linkedin\.com\/(mwlite\/|m\/)?(in|pub|sales|recruiter)(\/profile)?\/[\p{L}0-9\-_%]+(\/[\p{L}0-9\-_%]+){0,3}\/?$/u

export function normalizeLinkedInUrl(url) {
    if (!url) return url

    url = url.replace(/^linkedin:\/\/in\//, 'https://www.linkedin.com/in/')

    const redirectMatch = url.match(/linkedin\.com\/redir\/redirect\?url=([^&]+)/)
    if (redirectMatch) {
        url = decodeURIComponent(redirectMatch[1])
    }

    // Remove query params
    url = url.split('?')[0]

    // Ensure https scheme
    if (!/^https?:\/\//i.test(url)) {
        url = 'https://' + url
    }

    // ✅ Decode any encoded characters (like %C3%A1 → á)
    try {
        url = decodeURI(url)
    } catch (e) {
        // ignore if malformed
    }

    return url
}
